import Tip from '@/components/tip/Tip';
import { mapState } from "vuex";
import { externalFormatFilPrice, toBigInt } from "@/utils/NumU";
import PercentageMath from "@/utils/contracts/PercentageMath";
import { isEmpty } from "@/utils/model";
import { getLocal, getPrefix, gotoAddress, gotoHash, NotificationErr, NotificationSuccess, simpleValue } from "@/utils/common";
import { iWriteContract } from "@/utils/contracts/opertion";
import { contracts } from "@/utils/contracts/config";
import StakingPoolABI from "@/utils/abi/StakingPool.json";
import { ethers } from "ethers";
import IndicatorValue from './indicator/IndicatorValue';
import { formatUnits } from "ethers/lib.esm/utils";
import { E23, WadRayMath } from "@/utils/contracts/WadRayMath";
export default {
  name: "WithdrawP",
  components: {
    Tip,
    IndicatorValue
  },
  data() {
    return {
      sliderValue: 0,
      amount: '',
      amountFocus: false,
      loading: false,
      hash: '',
      btnText: ''
    };
  },
  watch: {
    sliderValue() {
      if (!this.amountFocus) {
        this.amount = parseFloat(ethers.utils.formatEther(PercentageMath.mul(this.maximumWithdrawal, toBigInt(this.sliderValue * 100)).toString())).toFixed(6);
      }
    },
    amount() {
      this.$store.commit('SET_YOU_ARE_WITHDRAW', {
        youAreWithdraw: this.amountByBigInt
      });
    }
  },
  methods: {
    gotoHash,
    simpleValue,
    gotoAddress,
    externalFormatFilPrice,
    sliderFormatTip(val) {
      return parseFloat(ethers.utils.formatEther(PercentageMath.mul(this.maximumWithdrawal, toBigInt(val * 100)).toString())).toFixed(6) + ' FIL';
    },
    clearContent() {
      this.btnText = '';
      this.hash = '';
    },
    goToRepay() {
      this.$emit('gotoRepay');
    },
    max() {
      this.amountFocus = true;
      this.amount = parseFloat(ethers.utils.formatEther(this.maximumWithdrawal));
      this.sliderValue = parseFloat((PercentageMath.div(ethers.utils.parseEther(this.amount.toString()).toBigInt(), this.maximumWithdrawal) / toBigInt(100)).toString());
      setTimeout(() => {
        this.amountFocus = false;
      }, 500);
    },
    amountValueChange() {
      if (this.amount < 0 || isEmpty(this.amount)) {
        this.amount = '';
        this.sliderValue = 0;
        return;
      }
      let max = parseFloat(ethers.utils.formatEther(this.maximumWithdrawal));
      if (this.amount > max) {
        this.amount = max.toFixed(6);
      }
      this.sliderValue = parseFloat((PercentageMath.div(ethers.utils.parseEther(this.amount.toString()).toBigInt(), this.maximumWithdrawal) / toBigInt(100)).toString());
    },
    amountValueFocus() {
      this.amountFocus = true;
    },
    amountValueBlur() {
      this.amountFocus = false;
    },
    withdraw() {
      if (this.approveOperator()) {
        return;
      }
      if (this.amount <= 0) {
        NotificationErr('Please enter the amount withdraw');
        return;
      }
      this.loading = true;
      this.btnText = this.$t('common.Wait for transaction confirmation');
      iWriteContract({
        address: contracts[this.$store.state.evn].StakingPool.eth,
        f0address: contracts[this.$store.state.evn].StakingPool.id,
        abi: StakingPoolABI.abi,
        functionName: "withdraw",
        args: [this.currentNode.node, ethers.utils.parseEther(this.amount.toString())]
      }, res => {
        let {
          hash
        } = res;
        this.btnText = this.$t('common.Waiting for winding');
        this.hash = hash;
      }).then(() => {
        setTimeout(() => {
          NotificationSuccess(`You have successfully withdraw ${this.amount.toString()} FIL !`);
          this.loading = false;
          this.$store.dispatch('updateRemoteNodeData', {
            node: this.currentNode.node
          });
          this.$emit('updateInfo');
          this.amount = '';
          this.clearContent();
        }, 5000);
      }).catch(err => {
        NotificationErr(err.message, "Ordinary withdrawals" + ` ${getLocal('connectType')}`);
        this.loading = false;
        this.clearContent();
      });
    },
    approveOperator() {
      if (this.operator === '0x0000000000000000000000000000000000000000') {
        this.$emit('approveOperator');
        return true;
      }
      if (this.isConnected && this.operator !== this.address) {
        NotificationErr('The current wallet is not the operator of this node');
        return true;
      }
      return false;
    },
    connectWallet() {
      if (this.approveOperator()) {
        return;
      }
      this.$store.state.refs['iHeader'].connectWallet();
    }
  },
  computed: mapState({
    assetsLoading: state => state.assetsLoading,
    oldOwnerShow() {
      if (this.oldOwner && this.oldOwner.toString().toLowerCase().startsWith("0xff00000000000")) {
        return getPrefix() + eval(this.oldOwner.toString().toLowerCase().replace("0xff", "0x")).toString(10);
      } else {
        return simpleValue(this.oldOwner ? this.oldOwner.toString() : null, 8, 8);
      }
    },
    operator() {
      return this.currentNode.operator;
    },
    marks() {
      return {
        0: '0',
        100: {
          style: {
            transform: 'translateX(-90%)'
          },
          label: externalFormatFilPrice(this.maximumWithdrawal, 4)
        }
      };
    },
    address() {
      return this.$store.state.address;
    },
    isExceedMaxDebtRate() {
      let equityValue = this.positionValue - this.debtValue;
      let maxPositionValue = equityValue * this.maxLeverage;
      let currentDebtRate = PercentageMath.div(this.debtValue * toBigInt(10000), maxPositionValue);
      return currentDebtRate > this.maxDebtRatio;
    },
    maximumWithdrawal() {
      if (this.debtRatio > this.maxDebtRatio) {
        return 0n;
      }
      let max = this.positionValue - this.safetyBuffer;
      if (max > this.availableBalance) {
        return this.availableBalance;
      }
      return max;
    },
    availableBalance() {
      return toBigInt(this.currentNode.availableBalance);
    },
    expectedAvailableBalance() {
      let res = this.availableBalance - this.amountByBigInt;
      if (res < 0n) {
        return 0n;
      }
      return res;
    },
    afterAvailableBorrowingAmount() {
      let position_value = toBigInt(this.currentNode.position_value) - this.amountByBigInt;
      let debt_value = toBigInt(this.currentNode.debt_value);
      let equityValue = position_value - debt_value;
      let res = PercentageMath.mul(equityValue, toBigInt(this.currentNode.max_leverage) - toBigInt(10000)) - debt_value;
      if (res < 0) {
        return 0n;
      }
      return res;
    },
    availableBorrowingAmount() {
      let position_value = toBigInt(this.currentNode.position_value);
      let debt_value = toBigInt(this.currentNode.debt_value);
      let equityValue = position_value - debt_value;
      let res = PercentageMath.mul(equityValue, toBigInt(this.currentNode.max_leverage) - toBigInt(10000)) - debt_value;
      if (res < 0) {
        return 0n;
      }
      return res;
    },
    firstExpectedInitialBalance() {
      let debt = this.debtValue;
      let tmp = PercentageMath.div(debt, this.maxLeverage - toBigInt(10000));
      return debt + (this.positionValue > tmp ? this.positionValue : tmp);
    },
    expectedInitialBalance() {
      let debt = this.debtValue - this.amountByBigInt;
      let tmp = PercentageMath.div(debt, this.maxLeverage - toBigInt(10000));
      return debt + (this.positionValue > tmp ? this.positionValue : tmp);
    },
    youAreBorrowing() {
      return this.$store.state.nodeData.youAreBorrowing;
    },
    afterSafetyBuffer() {
      if (this.youAreBorrowing <= 0) {
        if (this.youAreBorrowing + this.debtValue <= 0) {
          return 0n;
        }
        return this.safetyBuffer + this.youAreBorrowing;
      } else {
        let _debtValue = this.debtValue + this.youAreBorrowing;
        let tmp = PercentageMath.div(_debtValue, this.maxLeverage - toBigInt(10000));
        let sb1 = _debtValue + tmp;
        let sb2 = this.positionValue - this.availableBalance + this.youAreBorrowing;
        return sb1 > sb2 ? sb1 : sb2;
      }
    },
    amountByBigInt() {
      if (this.amount === '') {
        return 0n;
      }
      return ethers.utils.parseEther(this.amount.toString()).toBigInt();
    },
    positionValue() {
      return toBigInt(this.currentNode.position_value);
    },
    maxLeverage() {
      return toBigInt(this.currentNode.max_leverage);
    },
    debtValue() {
      return toBigInt(this.currentNode.debt_value);
    },
    oldOwner() {
      return this.currentNode.oldOwner;
    },
    safetyBuffer() {
      return toBigInt(this.currentNode.safetyBuffer);
    },
    stableRateEnabled: state => state.publicInfo.stableRateEnabled,
    poolIsPaused: state => state.publicInfo.poolIsPaused,
    isActive: state => state.currentNode.is_active === '1',
    simpleAddress() {
      if (!this.address) {
        return '';
      }
      return this.address.toString().substring(0, 6) + '...' + this.address.toString().substring(this.address.length - 2);
    },
    maxDebtRatio() {
      return PercentageMath.div(toBigInt(this.currentNode.max_leverage) - toBigInt(10000), toBigInt(this.currentNode.max_leverage));
    },
    isConnected() {
      return this.$store.state.isConnected;
    },
    isConnecting() {
      return this.$store.state.isConnecting;
    },
    currentNode() {
      return this.$store.state.nodeData.currentNode;
    },
    summaryPositionValue() {
      let res = this.positionValue - this.amountByBigInt;
      if (res < 0n) {
        return 0n;
      }
      return res;
    },
    summaryDebtValue() {
      return this.debtValue;
    },
    debtRatio() {
      if (this.debtValue === toBigInt(0)) {
        return toBigInt(0);
      }
      return PercentageMath.div(this.debtValue, this.positionValue);
    },
    summaryDebtRatio() {
      let debt = this.debtValue;
      if (debt === toBigInt(0)) {
        return toBigInt(0);
      }
      return toBigInt(parseInt(formatUnits(WadRayMath.rayDiv(debt, this.summaryPositionValue).toString(), 23)));
    },
    summaryLeverage() {
      return toBigInt(this.sliderValue / 100 * (this.currentNode.max_leverage - 10000) + 10000);
    },
    currentLeverage() {
      let equityValue = this.positionValue - this.debtValue;
      return PercentageMath.div(equityValue + this.debtValue, toBigInt(equityValue));
    },
    summarySafetyBuffer() {
      return 0;
    },
    equityValue() {
      return this.positionValue - this.debtValue;
    },
    variableBorrowRate: state => state.publicInfo.variableBorrowRate,
    stableBorrowRate: state => state.publicInfo.stableBorrowRate,
    userStableRate() {
      return this.currentNode.userStableRate;
    },
    currentFarmAPR() {
      return PercentageMath.mul(PercentageMath.div(this.positionValue, this.equityValue), toBigInt(this.maxBorrowRate / E23));
    },
    afterCurrentFarmAPR() {
      return PercentageMath.mul(PercentageMath.div(this.summaryPositionValue, this.equityValue), toBigInt(this.maxBorrowRate / E23));
    },
    maxBorrowRate: state => state.publicInfo.maxBorrowRate,
    currentBorrowingInterestAPR() {
      let _variable = PercentageMath.mul(this.variableDebtValue, toBigInt(this.variableBorrowRate / E23));
      let _stable = PercentageMath.mul(this.stableDebtValue, toBigInt(this.userStableRate / E23));
      return PercentageMath.div(_variable + _stable, this.equityValue);
    },
    afterCurrentBorrowingInterestAPR() {
      let addVariable = 0n;
      let addStable = 0n;
      if (this.radio3 === 'Variable') {
        addVariable = this.youAreBorrowing;
      } else {
        addStable = this.youAreBorrowing;
      }
      let _variable = PercentageMath.mul(this.variableDebtValue + addVariable, toBigInt(this.variableBorrowRate / E23));
      let _stable = PercentageMath.mul(this.stableDebtValue + addStable, toBigInt(this.userStableRate / E23));
      return PercentageMath.div(_variable + _stable, this.equityValue);
    },
    totalAPR() {
      return this.currentFarmAPR - this.currentBorrowingInterestAPR;
    },
    afterTotalAPR() {
      return this.afterCurrentFarmAPR - this.afterCurrentBorrowingInterestAPR;
    },
    dailyAPR() {
      return toBigInt(Math.floor(parseFloat(formatUnits(this.totalAPR.toString(), 2)) / 365 * 1000000));
    },
    afterDailyAPR() {
      return toBigInt(Math.floor(parseFloat(formatUnits(this.afterTotalAPR.toString(), 2)) / 365 * 1000000));
    },
    estimatedDailyEarnings() {
      return PercentageMath.mul(this.positionValue, this.dailyAPR) / 10000n;
    },
    afterEstimatedDailyEarnings() {
      return PercentageMath.mul(this.summaryPositionValue, this.afterDailyAPR) / 10000n;
    }
  })
};